import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { VipIcon } from 'shared/components/Icons';
import { isTop, isVIP } from 'shared/helpers/advert';

import s from './AdvertLabel.css';

class AdvertLabel extends React.Component {
  static propTypes = {
    advert: PropTypes.shape().isRequired,
    positin: PropTypes.string,
  };

  static defaultProps = {
    positin: 'topRight',
  };

  render() {
    const { advert, positin } = this.props;
    if (!advert.top_date && !advert.vip_date) return null;
    const posName = `position-${positin}`;
    const posClass = (s[posName] && { [s[posName]]: true }) || {};
    if (isVIP(advert))
      return (
        <div className={cx(s.vip, posClass)}>
          <VipIcon />VIP
        </div>
      );
    if (isTop(advert)) return <div className={cx(s.top, posClass)}>ТОП</div>;
    return null;
  }
}

export default withStyles(s)(AdvertLabel);



// WEBPACK FOOTER //
// ./src/shared/components/AdvertLabel/AdvertLabel.js